<span *ngIf="!isServerError">
  <app-courses-filters [periodFilterItems]="coursesTableData?.semesterFilter" 
    [typeFilterItems]="coursesTableData?.departmentFilter" 
    [searchPlaceholder]="pageData.searchPlaceholder"
    [disabled]="isLoading"
    [isLoading]="!isPageLoaded"
    [periodFilterMobileTitle]="pageData.mobilePeriodFilterTitle"
    [typeFilterMobileTitle]="pageData.mobileDepartmentFilterTitle"
    [searchValue]="searchTerm"
    (periodFilterChange)="periodFilterChangeEvent($event)"
    (typeFilterChange)="typeFilterChangeEvent($event)"
    (searchFiledChange)="onKeySearch($event)"
    ></app-courses-filters>

  <span *ngIf="!isLoading && isPageLoaded">
    <div class="courses-box" *ngFor="let department of coursesTableData.coursesList">
      <h4 class="box-title">{{department.department}}</h4>
  
      <mat-accordion>
        <app-course-item *ngFor="let course of department.courses" [data]="course" [linkTitle]="pageData.coursesLinksTitle" [creditsText]="pageData.creditsText" />
      </mat-accordion>
  
      <span *ngIf="department.courses.length != department.count">
        <button class="no-style load-more" (click)="loadMoreBtnClick(department.departmentId)" [disabled]="department.loading">
          {{getMoreBtnText(department.courses.length, department.count)}}
          <mat-icon *ngIf="!department.loading" [svgIcon]="'arrow-down'" class="square-icon load-more-icon"></mat-icon>
          <div *ngIf="department.loading" class="preloader--mini">
            <div class="preloader__icon course-more-loader">
                <img alt="" height="50" loading="lazy" src="Content/Images/icons/preloader.png?format=webp" width="50">
              </div>
          </div>
        </button>
      </span>
    </div>
    <div *ngIf="!coursesTableData.coursesList.length" class="courses-box no-results-text">
      <div>{{pageData.noResultsText}}</div>
    </div>
  </span>

  <span *ngIf="isLoading || !isPageLoaded">
    <div class="courses-box skeleton" *ngFor="let _ of [].constructor(2)">
      <app-skeleton [symbolsCount]="10" class="box-title" type="text"/>
      <app-skeleton class="course-title" *ngFor="let _ of [].constructor(3)" [height]="50"/>
    </div>
  </span>
</span>

<app-timeout-error-message *ngIf="isServerError"></app-timeout-error-message>